import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const SQL = () => {
  return (
    <StartInterviewLayout type="sql"/>
  )
}

export default SQL;